import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { TemperatureGraphData } from '../../types/device';

type ContextState = Data<TemperatureGraphData>;
const Context = React.createContext<ContextState | null>(null);

function useTemperatureGraphDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useTemperatureGraphDetails  must be used within a Temperature Graph');
    }
    return contextState;
};

const TemperatureGraphDataProvider: React.FC<{ deviceId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'temperature-graph',
        id: props.deviceId,
        dataFn: React.useCallback(() => ChartManager.getTemperatureGraphProperties(authHelper, props.deviceId), [
            authHelper,
            props.deviceId,
        ])
    });
    const temperatureGraphData = dataFromDataset(dataset);
  
    return <Context.Provider value={temperatureGraphData}>{props.children}</Context.Provider>;
};
const TestTemperatureGraphDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { TemperatureGraphDataProvider, TestTemperatureGraphDataProvider, useTemperatureGraphDetails };
